"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Widget", {
  enumerable: true,
  get: function get() {
    return _Widget["default"];
  }
});
Object.defineProperty(exports, "addNotificationAction", {
  enumerable: true,
  get: function get() {
    return _slice.addNotificationAction;
  }
});
Object.defineProperty(exports, "cleanNotification", {
  enumerable: true,
  get: function get() {
    return _commands.cleanNotification;
  }
});
Object.defineProperty(exports, "getNotifications", {
  enumerable: true,
  get: function get() {
    return _commands.getNotifications;
  }
});
Object.defineProperty(exports, "name", {
  enumerable: true,
  get: function get() {
    return _slice.name;
  }
});
Object.defineProperty(exports, "reducer", {
  enumerable: true,
  get: function get() {
    return _slice.reducer;
  }
});
Object.defineProperty(exports, "selectInProcess", {
  enumerable: true,
  get: function get() {
    return _slice.selectInProcess;
  }
});
Object.defineProperty(exports, "selectItems", {
  enumerable: true,
  get: function get() {
    return _slice.selectItems;
  }
});
Object.defineProperty(exports, "selectMeta", {
  enumerable: true,
  get: function get() {
    return _slice.selectMeta;
  }
});

var _Widget = _interopRequireDefault(require("./Widget"));

var _slice = require("./ducks/slice");

var _commands = require("./ducks/commands");